<template>
    <div class="administrative-units-panel">
        <div class="row">
            <div class="col-md-6">
                <administrative-units-map
                    :administrative-units="administrativeUnits"
                    :filtered-administrative-units="filteredUnits">
                </administrative-units-map>
            </div>

            <div class="col-md-6">
                <card-table title="Selection"></card-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        administrativeUnits: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            filteredUnits: {
                province: null,
                district: null,
                sector: null,
                cell: null,
                village: null,
            },
        };
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/administrative-units/AdministrativeUnitsPanel.vue